// --- 設定 ---
// 必須対象タグ（複数可）
const haiso_c_tagNames = ["交換商品","pimple block"];
// 日時指定必須エラーメッセージ
const haiso_error_msg ="この商品は日付と時間の指定が必須です。"
// 日付と時間帯の属性キー
const haiso_c_attributeKeys = ['haisoyamatoshippingdate', 'haisoyamatoshippingtime'];
// チェックアウトボタンのセレクタ
const checkoutBtnSelector = 'button[name="checkout"], .checkout-button';

// --- ヘルパー: カートの属性が入力値に一致するまで待つ ---
function waitForCartValues(maxSeconds = 10, intervalMs = 200) {
    return new Promise((resolve, reject) => {
        const start = Date.now();

        const check = () => {
            fetch("/cart.js", { method: "GET", headers: { "Accept": "application/json" } })
                .then(res => res.json())
                .then(cart => {
                    const attrs = cart.attributes || {};
                    let matched = true;

                    const dateInput = document.getElementById("haisoShippingdate")?.value;
                    const timeInput = document.getElementById("haisoShippingtime")?.value;


                    // Date just needs to exist
                    if (dateInput) {
                        matched = matched && attrs[haiso_c_attributeKeys[0]] && attrs[haiso_c_attributeKeys[0]].trim() !== "";
                    }

                    // Time  just needs to exist
                    if (timeInput) {
                        matched = matched && attrs[haiso_c_attributeKeys[1]] && attrs[haiso_c_attributeKeys[1]].trim() !== "";
                    }

                    if (matched) {
                        resolve(attrs); // 条件を満たしたら解決
                    } else if (Date.now() - start > maxSeconds * 1000) {
                        reject(new Error("カート属性が指定時間内に一致しませんでした"));
                    } else {
                        setTimeout(check, intervalMs); // 再試行
                    }
                })
                .catch(err => reject(err));
        };

        check();
    });
}

// --- カート内の商品タグと属性をチェック ---
function haisocfCheckCartItemsForTags(tags) {
    // 商品タグに対象タグが含まれているか確認
    const divElements = document.getElementsByClassName("item_tags");
    let hasTargetTag = Array.from(divElements).some(div => 
        tags.some(tag => div.innerHTML?.includes(tag))
    );

    const checkoutBtn = document.querySelector(checkoutBtnSelector);
    const msgDiv = document.getElementById('haiso_msg');
    if (!checkoutBtn || !msgDiv) return;

    if (hasTargetTag) {
        // タグがある場合はカート属性を確認（最大10秒までリトライ）
        waitForCartValues(10, 200)
            .then(cartAttributes => {
                // 入力必須の属性が空かどうか確認
                let missing = haiso_c_attributeKeys.filter(key => 
                    !cartAttributes[key] || cartAttributes[key].trim() === ""
                );

                if (missing.length > 0) {
                    checkoutBtn.disabled = true;
                    msgDiv.innerText = haiso_error_msg;
                    msgDiv.style.color = "red";
                } else {
                    checkoutBtn.disabled = false;
                    msgDiv.innerText = "";
                }
            })
            .catch(() => {
                // タイムアウトやエラー時もボタンを無効に
                checkoutBtn.disabled = true;
                msgDiv.innerText = haiso_error_msg;
                msgDiv.style.color = "red";
            });
    } else {
        // 対象タグがない場合は制御解除
        checkoutBtn.disabled = false;
        msgDiv.innerText = "";
    }
}

// --- #haisosm 内の input/select を監視 ---
var observe_haiso_time = false;
function observeInputsInside(container) {
    if (!container || observe_haiso_time) return;

    const mo = new MutationObserver(mutations => {
        mutations.forEach(m => {
            m.addedNodes.forEach(node => {
                if (node.className === "haiso_time") {
                    const timeInput = document.querySelector('#haisoShippingtime');
                    if (!timeInput) return;

                    // 入力イベントと変更イベントを監視してチェックを呼び出す
                  ["input", "change"].forEach(evt => {
                      timeInput.addEventListener(evt, () => haisocfCheckCartItemsForTags(haiso_c_tagNames));
                      observe_haiso_time = true;
                  });
                }
            });
        });
    });

    mo.observe(container, { childList: true, subtree: true });
    console.log("[haiso] #haisosm 内の input/select を監視開始");
}

// --- #haisosm の出現を監視 ---
const bodyObserver = new MutationObserver(() => {
    const sm = document.getElementById("haisosm");
    if (sm) observeInputsInside(sm);
});
bodyObserver.observe(document.body, { childList: true, subtree: true });

// --- カートの変化を監視 ---
const cartForm = document.querySelector('#cart');
if (cartForm) {
    const cartObserver = new MutationObserver(() => haisocfCheckCartItemsForTags(haiso_c_tagNames));
    cartObserver.observe(cartForm, { childList: true, subtree: true });
}

// --- 初回チェック ---
haisocfCheckCartItemsForTags(haiso_c_tagNames);

// --- カレンダー閉じるを検知 ---
let calendarCheckTimeouts = []; // 以前のタイマーを保持
function observeCalendarClose() {
    const $datepickerDiv = HaisoJquery("#ui-datepicker-div");
    let wasOpen = false;

    const observerCalendar = new MutationObserver(() => {
        const isVisible = $datepickerDiv.is(":visible");

       //  console.log($datepickerDiv);
       // if (!wasOpen && isVisible) console.log("[datepicker] カレンダー開く");
        if (wasOpen && !isVisible) {
           // console.log("[datepicker] カレンダー閉じる");
            // 以前のタイマーをキャンセル
            calendarCheckTimeouts.forEach(id => clearTimeout(id));
            calendarCheckTimeouts = [];
            // 4 回チェック実行
            const intervals = [0, 300, 900, 3000];
            let cumulativeTime = 0;

            intervals.forEach((ms, i) => {
                cumulativeTime += ms;
                const timeoutId = setTimeout(() => {
                    haisocfCheckCartItemsForTags(haiso_c_tagNames);
                 //   console.log(`[haiso] check cart run #${i + 1}`);
                }, cumulativeTime);

                // タイマーIDを配列に保持
                calendarCheckTimeouts.push(timeoutId);
            });
        }

        wasOpen = isVisible;
    });

    observerCalendar.observe($datepickerDiv[0], { attributes: true, attributeFilter: ["style"] });
}

// --- datepicker div の出現を監視 ---
const bodyMo = new MutationObserver(mutations => {
    for (const m of mutations) {
        for (const node of m.addedNodes) {
            if (node.id === "ui-datepicker-div") {
                observeCalendarClose(); // 監視開始
            }
        }
    }
});
bodyMo.observe(document.body, { childList: true, subtree: true });
